import $ from 'jquery';
import * as dmUploader from 'dm-file-uploader'
import jQueryUI from 'jquery-ui';
//https://github.com/danielm/uploader
class DragAndDropUploader {

  constructor(dragAndDropUploader) {

    this.init();

  }



  init() {

    //$("#sortable").sortable();

    $(".dropArea").dmUploader({
      url: "/api/"+$('html').attr('lang')+"/products/"+$("#drop-area").data("model_id")+"/store-picture",
      //maxFileSize: 3000000, // 3 Megs max
      allowedTypes: ['image/*'],
      extFilter: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic'],
      method: 'POST',
      headers: {
         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      onNewFile: function(id, file) {
        console.log(file)
        $("#loading-overlay").removeClass("hide");
      },
      // ...
      // onNewFile: function(id, file){
      //   //...
      //   if (typeof FileReader !== 'undefined'){
      //     var reader = new FileReader();
      //     var img = $('<img />');

      //     reader.onload = function (e) {
      //       img.attr('src', e.target.result);
      //     }
      //     /* ToDo: do something with the img! */
      //     reader.readAsDataURL(file);
      //   }
      // },
      onFileTypeError: function(file) {
        $("#loading-overlay").addClass("hide");
        swal('Attention', 'Only images allowed', 'warning');
      },
      onUploadSuccess: function(id, data) {
        $("#loading-overlay").addClass("hide");
        let resp = JSON.parse(data);
        $.ajax({
          url: "/"+$('html').attr('lang')+"/medias/"+resp.image_id+"/render-preview",
          success: function(data) {
            $(".gallery").append(data);
            $('.gallery').children().last().prev().foundation();
          }
        });
      }
      // ...
    });
  }

}


export default new DragAndDropUploader;
